var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEatClubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35px",
    viewBox: "0 0 775.97 791.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#E54439;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eatclub-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634.47,472.27c30.8,31,63.4,37.1,102.5,18.3,9.3-4.5,25.2,4.5,39,7.5-1.1,6.2-1.4,10.2-2.5,14-42.9,148.8-184.7,265-339.2,277.6-246.3,20-391.6-156.6-425.9-319.4-47-223.4,109.1-439.2,336.5-467.3a404.29,404.29,0,0,1,133.9,6.1c11.3,2.4,16.4,5.2,13.7,18.7-3,14.6-8.1,24.7-20.8,34.4-28.8,22-35.2,52.5-22.7,89-89.4-15.2-167.2,5.8-231.3,69.1-40.5,40-65.1,88.8-70.6,145.4-12.2,126.3,61.4,235.8,179.8,270C433,666.57,577.37,623.37,634.47,472.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.77,179.27c-19.9,26.1-31.5,53.2-25.6,85.7,5.2,28.6,19.8,50.5,43,67.7,5.4,4,10.9,11.3,11.4,17.6,5.5,62.9,56.4,103.7,119.1,94.5a43.39,43.39,0,0,1,5.1,0c-3,69.2-78.1,148.6-161.3,171.3-96,26.1-198.4-13.1-252.2-96.5-54.1-83.9-47.2-192.7,17.1-270.4C277.67,178.87,383.77,147.87,462.77,179.27Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEatClubIcon);
export default __webpack_public_path__ + "static/media/logoEatClubIcon.19b7087f.svg";
export { ForwardRef as ReactComponent };